import script from "./AccountDeactivatedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDeactivatedModal.vue?vue&type=script&setup=true&lang=js"

import "./AccountDeactivatedModal.vue?vue&type=style&index=0&id=0c618e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c618e12"]])

export default __exports__